import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react';

import { Label } from 'core';
import { Card } from 'core/components/card';
import Button from 'core/components/button/button';

import ProofOfElegibilityDocumentsBlock from './proof-of-elegibility-documents-block';
import AllHouseholdResidentsIncludedBlock from './all-household-residents-included-block';
import DescriptionOfPolicyChanges from './description-of-policy-changes';
import NewPIPFormRequiredBlock from './new-pip-form-required-block';

import useStyles from './changes-for-approval-section.styles';

const ChangesForApprovalSectionNonProcessingView = ({
  closePolicyPreviewModal,
  showProofOfEligibilityDocumentsBlock,
  showAllHouseholdResidentsIncludedBlock,
  showNewPIPFormRequiredBlock,
  goToPIPCoverageSection,
  openMemberDocuments,
  previewId
}) => {
  const classes = useStyles();
  const [isPIPFormLoading, setIsPIPFormLoading] = useState(false);

  return (
    <Card type="primary" className={classes.container}>
      <Label type="darkGreenSmallBold" className={classes.sectionTitle}>
        Please submit these changes for approval.
      </Label>
      <p className={classes.sectionDescription}>
        Because these changes impact the Personal Injury Protection (PIP) Medical limit, or affect the drivers and
        household residents linked to it, these policy changes will require approval from the Branch Underwriting
        Processing Team before they can be applied to the policy.
      </p>
      <p>Please review and complete the following requirements before submitting these changes for approval:</p>
      {showProofOfEligibilityDocumentsBlock && (
        <ProofOfElegibilityDocumentsBlock
          closePolicyPreviewModal={closePolicyPreviewModal}
          goToPIPCoverageSection={goToPIPCoverageSection}
          openMemberDocuments={openMemberDocuments}
        />
      )}
      {showAllHouseholdResidentsIncludedBlock && <AllHouseholdResidentsIncludedBlock />}
      {showNewPIPFormRequiredBlock && (
        <NewPIPFormRequiredBlock previewId={previewId} onLoadingStateChange={setIsPIPFormLoading} />
      )}
      <DescriptionOfPolicyChanges />
      <Grid container justifyContent="flex-end" spacing={2}>
        <Button
          id="submitChangesForApproval"
          name="submitChangesForApproval"
          type="submit"
          variant="contained"
          label="Add an internal note"
          mode="light"
          xs={3}
          color="primary"
          className={classes.submit}
          disabled={showNewPIPFormRequiredBlock && isPIPFormLoading}
        >
          Submit changes for approval
        </Button>
      </Grid>
    </Card>
  );
};

ChangesForApprovalSectionNonProcessingView.propTypes = {
  closePolicyPreviewModal: PropTypes.func.isRequired,
  showProofOfEligibilityDocumentsBlock: PropTypes.bool.isRequired,
  showAllHouseholdResidentsIncludedBlock: PropTypes.bool.isRequired,
  showNewPIPFormRequiredBlock: PropTypes.bool.isRequired,
  goToPIPCoverageSection: PropTypes.func.isRequired,
  openMemberDocuments: PropTypes.func.isRequired,
  previewId: PropTypes.string.isRequired
};

export default observer(ChangesForApprovalSectionNonProcessingView);
